
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { DistintaPerModello } from '@/models';

@Component
export default class ItemListDistintaConsumi extends Vue {
    @Prop() private distinta!: DistintaPerModello;

    private showDetail(distinta: DistintaPerModello) {
        this.$router.push({ name: 'distinta', params: { id: distinta.idDistintaDPC }});
    }
}
